export default __webpack_public_path__ + "static/media/12-28-12-maze.ee8f82de.m4a";